import { useState } from "react";
import type { OAuthProvider } from "@ugg/shared/components/auth/LoginFormFooter";
import { getAuthCallbackUrl } from "@ugg/shared/routes/app-routes";
import { useSupabaseAuth } from "@ugg/shared/components/auth/SupabaseAuthProvider";

export function useSiteOAuth(continueTo: string) {
  const { client } = useSupabaseAuth();
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState("");

  const authenticate = async (provider: OAuthProvider) => {
    setError("");
    setIsPending(true);
    const search = new URLSearchParams({ continue: continueTo, returnTo: window.location.pathname + window.location.search });
    const { error: oauthError } = await client.auth.signInWithOAuth({
      provider,
      options: { redirectTo: `${window.location.origin}${getAuthCallbackUrl(provider.replace("custom:", ""))}?${search}` },
    });
    if (oauthError) {
      setIsPending(false);
      setError(oauthError.message);
    }
  };

  return { authenticate, isPending, error };
}
